// extracted by mini-css-extract-plugin
export default {"reviews":"cAlMK9"};